const styles = theme => ({
  getConnectedBoxContainer: {
    padding: theme.spacing(2)
  },

  location: {
    fontWeight: "normal !important",
    color: theme.palette.primary.default
  },
  search: {
    marginBottom: theme.spacing(2)
  },

  connectWord: {
    marginRight: 10
  },

  organizationContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    borderBottom: "1px #CCCCCC solid"
  },
  searchTitle: {
    color: theme.palette.primary.default
  },

  avatarContainer: {
    marginRight: theme.spacing(2)
  },

  name: {
    color: "#78A1BB"
  },
  searchContainer: {
    height: "200px",
    overflowY: "auto"
  },
  connectButton: {
    textTransform: "unset"
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/components/SideBox/components/GetConnected/styles.js